const betTypeDescriptions = {
  W: "Win",
  P: "Place",
  S: "Show",
  WP: "Win-Place",
  WS: "Win-Show",
  WPS: "Win-Place-Show"
};

export default function betType(tournament) {
  if (tournament.get("tournament_type") === "Survivor") {
    return "Survivor";
  }
  return betTypeDescriptions[tournament.get("bet_type")];
}
